export const ROUTES = {
    ROOT: '/',
    NEWS: '/aktualnosci',
    TEAM: '/team',
    REHABILITACJA: '/rehabilitacja',
    CENNIK: '/cennik',
    KONTAKT: '/kontakt',
    PRIVACY: '/polityka-prywatnosci',
    ACCESSIBILITY: '/deklaracja-dostepnosci',
    YOUTH_PROTECT: '/standardy-ochrony-maloletnich',
};
